export const validateLead = (formData) => {
    const errors = {};

    if (!formData.full_name?.trim()) {
        errors.full_name = 'Full name is required';
    }

    if (!formData.email?.trim()) {
        errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        errors.email = 'Email is invalid';
    }

    if (!formData.phone?.trim()) {
        errors.phone = 'Phone is required';
    }

    if (formData.date && !/^\d{4}-\d{2}-\d{2}$/.test(formData.date)) {
        errors.date = 'Invalid date format (YYYY-MM-DD)';
    }

    if (formData.boat_id && !Number.isInteger(Number(formData.boat_id))) {
        errors.boat_id = 'Invalid boat selection';
    }

    return errors;
};
